import React from 'react'
import { Table, Input } from 'reactstrap'
import styled from 'styled-components'
import get from 'lodash/get'
import shortid from 'shortid'
import NumberFormat from 'react-number-format'
import TrashDefault from '../../../../static/images/trash-default.svg'
import TrashHover from '../../../../static/images/trash-hover.svg'
import { change_request_table_header } from '../../constants'
import { FONTS } from '../../../../constants'

export default class ChangeRequestTable extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (JSON.stringify(nextProps) === JSON.stringify(this.props)) return false
    return true
  }

  filterChangeRequest = (element) => {
    const search_change_request = get(this.props, 'search_change_request', '')
    if (search_change_request !== '' && element) {
      const name = element.name.toLowerCase()
      const description = element.description.toLowerCase()
      return name.includes(search_change_request.toLowerCase())
      || description.includes(search_change_request.toLowerCase())
    } return element
  }

  render() {
    const editChangeRequest = get(this.props, 'editChangeRequest')
    const projectByID = get(this.props, 'projectByID')
    const presale_snapshot = get(projectByID, 'presale_snapshot.snapshot')
    const rSelected = get(this.props, 'rSelected')
    const isPresale = presale_snapshot && rSelected === 1
    const change_requests = !isPresale ? get(this.props, 'change_requests', []) : get(presale_snapshot, 'change_requests')
    const handleChangeCost = get(this.props, 'handleChangeCost')
    const deleteChangeRequest = get(this.props, 'deleteChangeRequest')
    return (
    /* eslint no-underscore-dangle: 0 */
      <TableDiv>
        <NewTable bordered>
          <Header>
            <tr style={ { fontFamily: 'Gotham' } }>
              { change_request_table_header.map(v => {
                  return (
                    <th key={ shortid() }>{ v.label }</th>
                  )
                })
              }
            </tr>
          </Header>
          <BodyTable>
            { change_requests.filter(this.filterChangeRequest).map((change_request, key) => {
                return (
                  <tr key={ shortid() }>
                    <td>
                      <InputField
                        id={ key }
                        name='qt_number'
                        disabled={ !editChangeRequest }
                        defaultValue={ change_request.qt_number }
                        onBlur={ (e) => handleChangeCost(e) }
                      />
                    </td>
                    <td>
                      <InputField
                        id={ key }
                        name='name'
                        disabled={ !editChangeRequest }
                        defaultValue={ change_request.name }
                        onBlur={ (e) => handleChangeCost(e) }
                      />
                    </td>
                    <td>
                      <InputField
                        id={ key }
                        name='description'
                        disabled={ !editChangeRequest }
                        defaultValue={ change_request.description }
                        onBlur={ (e) => handleChangeCost(e) }
                      />
                    </td>
                    <td>
                      <NumberField
                        id={ key }
                        name='man_days'
                        disabled={ !editChangeRequest }
                        value={ change_request.man_days }
                        thousandSeparator={ true }
                        allowEmptyFormatting={ true }
                        decimalScale={ 2 }
                        fixedDecimalScale={ true }
                        onBlur={ (e) => {
                          // e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                          handleChangeCost(e)}  }
                      />
                    </td>
                    <td>
                      <NumberField
                        id={ key }
                        name='price'
                        disabled={ !editChangeRequest }
                        value={ change_request.price }
                        thousandSeparator={ true }
                        allowEmptyFormatting={ true }
                        decimalScale={ 2 }
                        fixedDecimalScale={ true }
                        onBlur={ (e) => {
                          // e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                          handleChangeCost(e)}  }
                      />
                    </td>
                    <td>
                      <Trash
                        onClick={
                          editChangeRequest ?
                            () => deleteChangeRequest(key)
                            : () => { }
                        }
                        edit={editChangeRequest}
                      />
                    </td>
                  </tr>
                )
              })
            }
          </BodyTable>
        </NewTable>
      </TableDiv>
    )
  }
}

const NewTable = styled(Table)`
  background: white;
  margin-bottom: 10%;
  thead, tbody tr{
    display:table;
    width:100%;
    table-layout:fixed;
  }thead th{
    background-color: #404040;
    font-family: ${FONTS.GOTHAM_MEDIUM} !important;
    font-size: ${FONTS.SMALL_SIZE};
    border: none;
  }
  @media (max-width: 575.98px) {
    width:800px;
  thead, tbody tr{
    display:table;
    width:100%;
    table-layout:fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE};
  }
  td {
    padding-left: 1%;
  }
  th {
      padding-left: 1% ;
    }
  }
  @media (max-width: 767.98px) {
    width:800px;
  td {
    padding-left: 1%;
  }
  th {
    padding-left: 1% ;
  }
}
@media (max-width: 991.98px) {
    width:800px;
  td {
    padding-left: 1%;
  }
  th {
    padding-left: 1% ;
  }
  }
`
const BodyTable = styled.tbody`
  @media (max-width: 1024px) {
    max-height: calc(100vh - 380px);
  }

  width: 100% ;
  display: block ;
  max-height: calc(100vh - 360px);
  overflow-y:scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`
const TableDiv = styled.div`
  padding-bottom: 30px;
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  @media (max-width: 575.98px) {
    padding-right: 0px;
    padding-left: 0px;
    font-size: 12px;
    width:100vw;
    overflow:scroll;
  }
  @media (max-width: 767.98px) {
    padding-right: 0px;
    padding-left: 0px;
    font-size: 12px;
    width:100vw;
    overflow:scroll;
  }
`
const Header = styled.thead`
  background: black;
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
`
const NumberField = styled(NumberFormat)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  width : 80% ;
  margin-left: 10% ;
  margin-right: 10% ;
  border-radius: 5px;
  text-align:right;
  border: 1px solid #CCCCCC;
  background-color: ${props => {
  const status = props.disabled
  if (status === !get(this.props, 'edit_change_request')) {
    return '#E8ECEF'
  }
  return '#FFFFFF'
  }};
`
const InputField = styled(Input)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  width : 100% ;
  height : 100% ;
`
const Trash = styled.div`
  background-image: ${props => {
  const edited = props.edit
  if (edited) {
    return `url(${TrashHover})`
  }
  return `url(${TrashDefault})`
}};
  background-repeat: no-repeat;
  align-self: center;
  border:0;
  width: 20px ;
  height: 20px ;
  margin: auto ;
  cursor: ${props => { return props.edit ? 'pointer' : 'default' }};
`



// WEBPACK FOOTER //
// ./src/components/project-information/table/table-change-request/index.js